<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row class="mb-3">
          <b-col cols="12" class="mt-1">
            <h4>{{ $t('global.error_reports_view_title') }}</h4>
          </b-col>
        </b-row>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row v-if="errorReport">
            <b-col cols="12">
              <div>
                <p class="font-weight-bold">{{ $t('global.email') }}:</p>
                <p class="ml-2">{{ errorReport.user ? errorReport.user.email : $t('global.anonymous') }}</p>
              </div>
              <div>
                <p class="font-weight-bold">{{ $t('global.description') }}:</p>
                <p class="ml-2">{{ errorReport.description }}</p>
              </div>
              <div>
                <p class="font-weight-bold">{{ $t('global.created_at') }}:</p>
                <p class="ml-2">{{ errorReport.created_at }}</p>
              </div>
              <div>
                <p class="font-weight-bold">{{ $t('global.logs') }}:</p>
                <div>
                  <b-button :disabled="!errorReport.main_log_path" variant="primary" class="mr-2" @click="downloadLog('main')">
                    Main
                  </b-button>
                  <b-button :disabled="!errorReport.renderer_log_path" variant="primary" class="mr-2" @click="downloadLog('renderer')">
                    Renderer
                  </b-button>
                  <b-button :disabled="!errorReport.main_log_path" variant="primary" class="mr-2" @click="downloadLog('state')">
                    State
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Services from '@/services';

export default {
  name: 'ErrorReport',
  props: ['id'],
  data() {
    return {
      errorReport: null,
      spinners: {
        contentIsLoading: false,
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.spinners.contentIsLoading = true;

      Services.errorReports.view(this.id).then(({ data }) => {
        console.log(data);
        this.errorReport = data;
      }).catch(() => {
        this.alertError();
      }).finally(() => {
        this.spinners.contentIsLoading = false;
      });
    },
    downloadLog(log) {
      Services.errorReports.download(this.id, log).then(({ data }) => {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        const ext = log === 'state' ? 'json' : 'log';

        link.href = url;
        link.setAttribute('download', `${log}.${ext}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }).catch(() => {
        this.alertError();
      });
    }
  },
};
</script>
